import * as actions from './actions';

export const defaultState = () => ({
  incident: null,
  error: null,
  isPosting: false
});

const eventsReducer = (state = defaultState(), action) => {
  switch (action.type) {
    case actions.POST_INCIDENT_REQUEST:
      return {
        ...state,
        isPosting: true
      };
    case actions.POST_INCIDENT_SUCCESS:
      return {
        ...state,
        incident: action.payload,
        isPosting: false
      };
    case actions.POST_INCIDENT_FAILURE:
      return {
        ...state,
        error: action.payload,
        isPosting: false
      };
    default:
      return state;
  }
};

export default eventsReducer;
